import { AnimatePresence, motion } from "framer-motion";

const STEPS = 6;

// Six columns sweep up off the screen, staggered right-to-left, on every page change.
const StairTransition = ({ routeKey }) => (
  <AnimatePresence mode="wait">
    <div key={routeKey}>
      <div className="h-screen w-screen fixed top-0 left-0 right-0 pointer-events-none z-40 flex">
        {[...Array(STEPS)].map((_, i) => (
          <motion.div
            key={i}
            className="h-full w-full bg-accent relative"
            initial={{ top: "0%" }}
            animate={{ top: "100%" }}
            exit={{ top: ["100%", "0%"] }}
            transition={{ duration: 0.4, ease: "easeInOut", delay: (STEPS - i - 1) * 0.1 }}
          />
        ))}
      </div>
      <motion.div
        className="h-screen w-screen fixed bg-primary top-0 pointer-events-none z-30"
        initial={{ opacity: 1 }}
        animate={{ opacity: 0, transition: { delay: 1, duration: 0.4, ease: "easeInOut" } }}
      />
    </div>
  </AnimatePresence>
);

export default StairTransition;
